<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']">
    <a-card :bordered="false">
      <a-form>
        <a-form-item label="活动界次" :labelCol="{xs: { span: 8 },sm: { span: 2 }}" :wrapperCol="{xs: { span: 16 },sm: { span: 22 }}">
          <j-dict-select-tag
            :defaultShowAll="true"
            type="radioButton"
            v-model="queryParam.eventId"
            @change="eventChange"
            :trigger-change="true"
            dictCode="event_orders"
          />
        </a-form-item>
        <a-form-item label="排序方式" :labelCol="{xs: { span: 8 },sm: { span: 2 }}" :wrapperCol="{xs: { span: 16 },sm: { span: 22 }}">
          <a-radio-group button-style="solid" v-model="queryParam.orderBy" @change="getList">
            <a-radio-button value="time">
              最近更新
            </a-radio-button>
            <a-radio-button value="view">
              播放最多
            </a-radio-button>
            <a-radio-button value="like">
              推荐最多
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form>
      <a-divider />
      <a-skeleton v-if="loading" />
      <a-list
        :grid="{ gutter: _isMobile() ? 12 : 24, lg: 4, md: 3, sm: 2, xs: 1 }"
        :dataSource="dataSource"
        :pagination="pagination"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card :bordered="false" @click="toDetail(item)">
            <div class="img-zoom">
              <img class="cover" :src="item.cmsCover_url" alt="" />
            </div>

            <h3 class="title">{{ item.cmsTitile }}</h3>
          </a-card>
        </a-list-item>
      </a-list>
    </a-card>

    <a-modal
      :width="800"
      :visible="videoVisible"
      :maskClosable="false"
      :title="currentItem.cmsTitile"
      :destroyOnClose="true"
      @cancel="videoVisible = false"
      :footer="null"
    >
      <video
        style="width: 100%"
        controls
        oncontextmenu="return false;"
        controlsList='nodownload noremote footbar'
        autoplay
        :src="currentItem.extraFile_url"
      ></video>
    </a-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import "@/assets/less/animation.css";

export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
  },
  data() {
    return {
      dataSource: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: this._isMobile() ? 8 : 12,
      },
      loading: true,
      productType: "",
      tenantConfig: {},
      videoVisible: false,
      currentItem: {},
      queryParam: {
        cmsType: 5,
        pageSize: 999,
        cmsStatus: 1,
        orderBy: 'time',
        eventId: ''
      },
    };
  },
  created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    this.getList();
  },
  mounted() {},
  methods: {
    eventChange(v){
      this.queryParam.eventId = v.target.value
      this.getList()
    },
    getList() {

      this.loading = true;
      this.dataSource = [];
      getAction("/teaching/teachingCms/getCmsList", this.queryParam).then((res) => {
        console.log(res);
        if (res.success) {
          this.dataSource = res.result.records;
        }
        this.loading = false;
      });
    },
    toDetail(item) {
      this.currentItem = item;
      this.videoVisible = true;
      getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id).then(res=>{

      })
    },
  },
};
</script>

<style lang="less" scoped>
.img-zoom {
  width: 100%;
  height: 170px;
  border-radius: 4px;
  box-shadow: rgb(179, 179, 179) 0px 0px 5px;
  img {
    width: 100%;
    height: 100%;
  }
}
.title {
  margin-top: 5px;
}
.title:hover {
  color: #1890ff;
}
.search-card {
  /deep/.ant-card-body {
    padding: 20px;
  }
}
/deep/.ant-list-item {
  cursor: pointer;
  .ant-card-body {
    padding: 0;
  }
}
.mobile {
  .cover {
    height: 100px !important;
  }
}
</style>